import React, { useState, useEffect } from 'react';
import {
  isMobile,
  isIE,
  isWindows,
  isSafari,
  isChrome,
  isIOS,
  isAndroid,
  isFirefox,
  isEdge,
  isEdgeChromium
} from 'react-device-detect';
// import { SumerianScene } from 'aws-amplify-react';
import { SumerianSceneParent } from '../';
import { BrowserIncompatible } from '../';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import NavigationMenuImage from '../../images/navigation_menu.png';

export default function BrowserDetection() {
  const [browserDetectionMsg, setBrowserDetectionMsg] = useState('');
  const [browserIncompatible, setBrowserIncompatible] = useState(false);
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    window.location = 'https://northsplit.com/virtual-project-office/';
  };

  useEffect(() => {
    // console.log('is edge chromium', isEdgeChromium);
    // console.log('is edge ', isEdge);
    if (isMobile) {
      if (isIOS) {
        setBrowserIncompatible(true);
        setBrowserDetectionMsg(
          'Sorry, Apple mobile devices are not currently able to experience the virtual project office.'
        );
      } else if (isAndroid) {
        setBrowserDetectionMsg(
          'Android mobile devices have limited support for experiencing the virtual project office. For best results, please use Firefox or Chrome on PC or Mac.'
        );
      }
    } else {
      if (isWindows) {
        if (isIE) {
          setBrowserIncompatible(true);
          setBrowserDetectionMsg(
            'Sorry, Internet Explorer is not able to experience the virtual project office.'
          );
        } else if (isSafari) {
          setBrowserDetectionMsg(
            'You are using Windows Safari, which has limited support for experiencing the virtual project office.'
          );
        } else if (isChrome) {
          setBrowserDetectionMsg(
            ''
          );
        }
      } else {
        // mac/linux desktop
        if (isIE) {
          setBrowserIncompatible(true);
          setBrowserDetectionMsg(
            'Sorry, Internet Explorer is not able to experience the virtual project office.'
          );
        } else if (isSafari) {
          setBrowserDetectionMsg(
            'You are using Mac Safari, which has limited support for experiencing the virtual project office.'
          );
        } else if (isChrome) {
          setBrowserDetectionMsg(
            ''
          );
        }
      }
    }
  }, []);
  return (
    <div>
      {open ? (
        <Dialog
          disableBackdropClick
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {browserIncompatible
              ? 'Incompatible Browser Detected'
              : ''}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {browserDetectionMsg}
            </DialogContentText>
            {isChrome && !isMobile && (
              <div>
                <img
                  style={{ width: '100%', borderRadius: 15 }}
                  alt="navigation-menu"
                  src={NavigationMenuImage}
                ></img>
              </div>
            )}
            {!isChrome && !isIE && !isMobile && (
              <div>
                <img
                  style={{ width: '100%', borderRadius: 15 }}
                  alt="navigation-menu"
                  src={NavigationMenuImage}
                ></img>
              </div>
            )}
            {isMobile && !isIOS && (
              <div>
                <img
                  style={{ width: '100%', borderRadius: 15 }}
                  alt="navigation-menu"
                  src={NavigationMenuImage}
                ></img>
              </div>
            )}
          </DialogContent>
          {browserIncompatible ? (
            <BrowserIncompatible />
          ) : (
            <DialogActions>
              <Button onClick={handleClose} variant="contained" color="primary">
                Continue
              </Button>
              <Button
                onClick={handleCancel}
                variant="contained"
                color="primary"
              >
                Return
              </Button>
            </DialogActions>
          )}
        </Dialog>
      ) : (
        <div style={{ height: '100vh' }}>
          {/* Old component that isn't customizable <SumerianScene sceneName="nsvpo" /> */}
          <SumerianSceneParent />
        </div>
      )}
    </div>
  );
}
